/**
 * Labstep
 *
 * @module components/Notification/Action/Menu
 * @desc Action Menu for notification
 */

import NotificationActionDisable from 'labstep-web/components/Notification/Action/Disable';
import { NOTIFICATIONS_DEFINITIONS } from 'labstep-web/constants/user-group-notification';
import { Dropdown } from 'labstep-web/core/Dropdown';
import { Icon } from 'labstep-web/core/Icon';
import { useActiveGroup } from 'labstep-web/hooks/activeGroup';
import type React from 'react';
import { useState } from 'react';
import type { NotificationActionMenuProps } from './types';

export const NotificationActionMenu: React.FC<
  NotificationActionMenuProps
> = ({ notification, actions, type }) => {
  const [open, setOpen] = useState(false);
  const { activeGroup } = useActiveGroup();
  if (!activeGroup) {
    return null;
  }
  const typesWithSettings = Object.keys(
    NOTIFICATIONS_DEFINITIONS,
  ).reduce(
    (result: string[], key) => [
      ...result,
      ...Object.keys(NOTIFICATIONS_DEFINITIONS[key]),
    ],
    [],
  );
  if (typesWithSettings.indexOf(notification.type) === -1) {
    return null;
  }
  return (
    <Dropdown.Dropdown
      type={type}
      open={open}
      onOpen={() => setOpen(true)}
      onClose={() => setOpen(false)}
      pointing="top right"
      icon={null}
      trigger={<Icon name="ellipsis vertical" />}
    >
      <Dropdown.Menu>
        {!open && <Dropdown.Item>Placeholder</Dropdown.Item>}
        {actions.includes('disable') && open && (
          <NotificationActionDisable notification={notification} />
        )}
      </Dropdown.Menu>
    </Dropdown.Dropdown>
  );
};

NotificationActionMenu.defaultProps = {
  actions: [],
  type: 'icon',
};
